const SCAN_RESULT_STATUS = {
    INVALID_TAG: 'INVALID_TAG',
    INVALID_TAG_PATTERN: 'INVALID_TAG_PATTERN',
    DUPLICATE_SCAN: 'DUPLICATE_SCAN',
    NEW_TAG: 'NEW_TAG',
    NO_ASSET_ACCESS: 'NO_ASSET_ACCESS',
    ASSET_FOUND: 'ASSET_FOUND',
    ASSET_FOUND_BUT_MOVED: 'ASSET_FOUND_BUT_MOVED'
};

export { SCAN_RESULT_STATUS };
